<script setup>
import SubscriptionPrice from '@/Components/SubscriptionPrice.vue'
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTrigger,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from '@codinglabsau/gooey'

defineProps({
  downloadHref: String,
})
</script>

<template>
  <Button v-if="$page.props.auth.user?.supporter" v-bind="$attrs">
    <slot />
  </Button>
  <Dialog v-else>
    <DialogTrigger as-child>
      <Button variant="outline">
        <slot />
      </Button>
    </DialogTrigger>

    <DialogContent>
      <DialogHeader>
        <DialogTitle>Become a supporter to unlock this feature</DialogTitle>
        <DialogClose />
      </DialogHeader>

      <DialogDescription class="mb-4 flex w-full text-gray-600">
        <slot name="feature-description"
          >You will need to subscribe as a supporter to use this feature.</slot
        >
      </DialogDescription>
      <SubscriptionPrice />
    </DialogContent>
  </Dialog>
</template>
